module.exports = __webpack_public_path__ + "static/img/N-Nuvolos-blue.9d4ed140.svg";